import { render, staticRenderFns } from "./vodaOrphanDogovor.vue?vue&type=template&id=2afb1572"
import script from "./vodaOrphanDogovor.vue?vue&type=script&lang=js"
export * from "./vodaOrphanDogovor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports